<template>
  <v-container tag="section" class="px-10 pb-10">
    <v-overlay :value="isLoadingActions">
      <v-progress-circular color="#FBB040" indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-skeleton-loader :loading="isLoading" type="card, card, card" max-width="50%">
      <v-row justify="end" class="pr-2">
        <v-col cols="12" sm="auto">
          <v-btn x-large color="success" class="text-white" width="100%" @click="onPrint"
            ><v-icon right dark class="mr-2"> mdi-update </v-icon>
            In phiếu bảo hành
          </v-btn>
        </v-col>
        <v-col cols="12" sm="auto">
          <v-btn
            color="error"
            x-large
            class="text-white"
            min-width="180"
            width="100%"
            button
            dark
            @click="actionsDelete"
          >
            <v-icon right dark class="mr-2"> mdi-plus-box </v-icon>
            Xoá bỏ
          </v-btn>
        </v-col>
        <v-col cols="12" sm="auto">
          <v-btn x-large color="primary" class="text-white" width="100%" @click="onUpdate"
            ><v-icon right dark class="mr-2"> mdi-update </v-icon>
            Cập nhật
          </v-btn>
        </v-col>
        <v-col cols="12" sm="auto">
          <v-btn x-large color="purple" class="text-white" width="100%" @click="onCreate"
            ><v-icon right dark class="mr-2"> mdi-plus-box </v-icon>
            Tạo sao chép
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-expansion-panels v-model="panel" multiple>
              <v-expansion-panel>
                <v-expansion-panel-header class="text-xl font-medium">
                  Chi tiết bảo hành
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row class="mt-5">
                    <v-col cols="12" sm="6" lg="6">
                      <v-text-field
                        v-model="productName"
                        outlined
                        :rules="[rules.required]"
                        prepend-inner-icon="mdi-numeric"
                        color="#FBB040"
                        label="Tên sản phẩm*"
                        :hide-details="true"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" lg="6">
                      <v-text-field
                        v-model="productIMEI"
                        outlined
                        :rules="[rules.required]"
                        prepend-inner-icon="mdi-code-array"
                        color="#FBB040"
                        label="IMEI*"
                        :hide-details="isMobile"
                      />
                    </v-col>
                  </v-row>
                  <v-row class="mt-1">
                    <v-col cols="12" sm="6" lg="6">
                      <v-select
                        v-model="productStatus"
                        prepend-inner-icon="mdi-state-machine"
                        color="#FBB040"
                        :items="productStatusList"
                        outlined
                        :rules="[rules.required]"
                        no-data-text="Không có dữ liệu"
                        label="Tình trạng sản phẩm*"
                        item-text="name"
                        loading="true"
                        item-value="id"
                        :hide-details="isMobile"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" lg="6">
                      <money-input
                        v-model="productPrice"
                        v-bind:label="label"
                        v-bind:placeholder="placeholder"
                        v-bind:readonly="readonly"
                        v-bind:disabled="disabled"
                        v-bind:outlined="outlined"
                        v-bind:clearable="clearable"
                        v-bind:valueWhenIsEmpty="valueWhenIsEmpty"
                        v-bind:options="options"
                        v-bind:properties="properties"
                        :rules="[rules.required]"
                      />
                    </v-col>
                  </v-row>
                  <v-row class="mt-1">
                    <v-col cols="12" sm="6" lg="6">
                      <DatePicker
                        :rules="[rules.required]"
                        v-model="productDateBuy"
                        label="Ngày mua*"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" lg="6">
                      <v-select
                        v-model="productBuyWay"
                        prepend-inner-icon="mdi-sign-yield"
                        color="#FBB040"
                        :items="productBuyWayList"
                        outlined
                        :rules="[rules.required]"
                        no-data-text="Không có dữ liệu"
                        label="Hình thức mua*"
                        item-text="name"
                        loading="true"
                        item-value="id"
                        :hide-details="isMobile"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" lg="6">
                      <v-text-field
                        v-model="productGuarran"
                        outlined
                        prepend-inner-icon="mdi-account-child"
                        color="#FBB040"
                        label="Bảo hành*"
                        :hide-details="isMobile"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" lg="6">
                      <v-text-field
                        v-model="productGuarranDate"
                        outlined
                        disabled
                        prepend-inner-icon="mdi-archive-clock-outline"
                        color="#FBB040"
                        label="Ngày hết hạn*"
                        :hide-details="isMobile"
                      />
                    </v-col>
                  </v-row>
                  <v-row class="mt-1">
                    <v-col cols="12" sm="6" lg="6">
                      <v-text-field
                        v-model="productCustomerName"
                        outlined
                        :rules="[rules.required]"
                        prepend-inner-icon="mdi-account-arrow-up"
                        color="#FBB040"
                        label="Tên khách hàng*"
                        :hide-details="isMobile"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" lg="6">
                      <v-text-field
                        v-model="productCustomerPhone"
                        outlined
                        prepend-inner-icon="mdi-phone"
                        color="#FBB040"
                        label="Số điện thoại"
                        :hide-details="isMobile"
                        :maxLength="20"
                        @keypress="filter(evt)"
                      /> </v-col
                  ></v-row>
                  <v-row class="mt-1">
                    <v-col cols="12" sm="6" lg="6">
                      <v-text-field
                        v-model="productIcloud"
                        outlined
                        :rules="[rules.required]"
                        prepend-inner-icon="mdi-apple-icloud"
                        color="#FBB040"
                        label="Tài khoản icloud*"
                        :hide-details="isMobile"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" lg="6">
                      <v-text-field
                        v-model="productIcloudPassword"
                        outlined
                        prepend-inner-icon="mdi-form-textbox-password"
                        color="#FBB040"
                        :rules="[rules.required]"
                        label="Mật khẩu*"
                        :hide-details="isMobile"
                      /> </v-col
                  ></v-row>
                  <v-row class="mt-1">
                    <v-col cols="12" sm="6" lg="12">
                      <v-text-field
                        v-model="productNote"
                        outlined
                        prepend-inner-icon="mdi-apple-icloud"
                        color="#FBB040"
                        label="Lưu ý"
                        :hide-details="isMobile"
                      /> </v-col
                  ></v-row>
                  <v-row class="mt-1">
                    <v-col cols="12" sm="6" lg="6">
                      <v-text-field
                        v-model="createdAt"
                        outlined
                        prepend-inner-icon="mdi-apple-icloud"
                        color="#FBB040"
                        label="Ngày tạo"
                        :hide-details="isMobile"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" lg="6">
                      <v-text-field
                        v-model="updatedAt"
                        outlined
                        prepend-inner-icon="mdi-apple-icloud"
                        color="#FBB040"
                        label="Cập nhật"
                        :hide-details="isMobile"
                      /> </v-col
                  ></v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-form>
        </v-col>
      </v-row>
    </v-skeleton-loader>
  </v-container>
</template>

<script>
import { EMPTY } from "~/utils/constants";
import { assignObjWithExistKey } from "~/utils";
import { required } from "~/utils/validation";
import { mapState } from "vuex";
import CardMedicine from "~/components/atoms/CardMedicine";
import VueUploadMultipleImage from "~/components/molecules/VueUploadMultipleImage.vue";
import DatePicker from "~/components/atoms/DatePicker.vue";
import MoneyInput from "~/components/atoms/MoneyInput.vue";

export default {
  name: "PrescriptionBaseDetail",
  components: { CardMedicine, DatePicker, VueUploadMultipleImage, MoneyInput },
  data() {
    return {
      scope: "productbuy",
      productCustomerName: null,
      productPrice: null,
      productBuyWay: 1,
      productCustomerName: null,
      productCustomerPhone: null,
      productName: null,
      productIcloud: null,
      productIMEI: null,
      productIcloudPassword: null,
      productStatus: 1,
      productNote: null,
      label: "Giá sản phẩm*",
      placeholder: " ",
      readonly: false,
      disabled: false,
      outlined: true,
      clearable: true,
      createdAt: null,
      updatedAt: null,
      valueWhenIsEmpty: "",
      options: {
        locale: "it-IT",
        prefix: "",
        suffix: "vnđ",
        length: 30,
        precision: 0,
      },
      rules: {
        required,
      },
      properties: {
        hint: "Chú ý đơn vị tính",
        prependInnerIcon: "mdi-currency-usd",
        color: "#FBB040",
      },
      productGuarran: null,
      productBuyWayList: [
        {
          id: 1,
          name: "Trả góp",
        },
        {
          id: 2,
          name: "Trả thẳng",
        },
      ],
      productStatusList: [
        {
          id: 1,
          name: "Hàng 100%",
        },
        {
          id: 2,
          name: "Hàng 99%",
        },
        {
          id: 3,
          name: "Hàng 98%",
        },
        {
          id: 4,
          name: "Hàng 97%",
        },
        {
          id: 5,
          name: "Hàng 96%",
        },
        {
          id: 6,
          name: "Hàng 95%",
        },
      ],
      publicIds: [],
      phoneList: [],
      panel: [0],
      messageError: EMPTY,
      productDateBuy: null,
      valid: false,
      isLoading: false,
      isLoadingActions: false,
    };
  },
  async created() {
    try {
      this.isLoading = true;
      const { phonbuyid } = this.$route.params;
      const data = await this.$services.phonebuyService.getPhoneBuy(phonbuyid);

      if (data) {
        this.productName = data?.productName;
        this.productIMEI = data?.productIMEI;
        this.productDateBuy = data?.productDateBuy;
        this.productStatus = parseInt(data?.productStatus);
        this.productPrice = data?.productPrice;
        this.productBuyWay = parseInt(data?.paymentMethod);
        this.productGuarran = data?.productGuarranName;
        this.productCustomerName = data?.customerName;
        this.productCustomerPhone = data?.customerPhone;
        this.productIcloud = data?.customerCloud;
        this.productIcloudPassword = data?.customerCloudPassword;
        this.productNote = data?.note;
        this.createdAt = data?.createdAt;
        this.updatedAt = data?.updatedAt;
      }
    } catch (err) {
      console.log(err);
    } finally {
      this.isLoading = false;
    }
  },
  beforeDestroy() {
    this.$store.commit("elevator/setImageList", []);
  },
  computed: {
    ...mapState({
      elevatorBranchList: (state) => state.elevatorBranchList,
      images: (state) => state.elevator.images,
      totalImage: (state) => state.elevator.totalImage,
    }),
    isMobile() {
      return window.innerWidth <= 640;
    },
  },
  methods: {
    async actionsDelete() {
      this.$modal.show({
        title: "Xác nhận xoá bảo hành này?",
        visible: true,
        callbackConfirm: async () => this.removeBaoHanh(),
      });
    },
    filter(evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async removeBaoHanh() {
      const { phonbuyid } = this.$route.params;
      try {
        this.isLoadingActions = true;
        await this.$services.phonebuyService.deletePhoneBuyByID(phonbuyid);
      } catch (err) {
        console.log(err);
      } finally {
        this.isLoadingActions = false;
        this.$router.push({ name: "PhoneBuyList" });
      }
    },
    imageUploadLoading(isLoadingActions) {
      this.isLoadingActions = isLoadingActions;
    },
    onUpload(listImages) {
      this.$store.commit("elevator/setImageList", listImages);
      this.messageError = EMPTY;
    },
    onEditImage(listImages) {
      this.messageError = EMPTY;
      this.$store.commit("elevator/setImageList", listImages);
    },
    beforeRemove(_, done) {
      this.$modal.show({
        title: "Bạn muốn xóa ảnh này không ?",
        visible: true,
        callbackConfirm: async () => {
          const images = await done();
          this.$store.commit("elevator/setImageList", images);
        },
      });
    },
    onPrint() {
      const { phonbuyid } = this.$route.params;
      const routeData = this.$router.resolve({
        name: "PhieuBaoHanh",
        params: { phonbuyid: phonbuyid },
      });
      window.open(routeData.href, "_blank");
    },
    onLimitExceeded() {
      this.messageError = `Gói này CHỈ CHO PHÉP SỐ HÌNH TỐI ĐA là ${this.totalImage}`;
    },
    async onCreate() {
      await this.$refs.form.validate();
      this.errorMessage = EMPTY;
      try {
        if (this.valid) {
          this.isLoadingActions = true;
          const publicIdList = this.images.map((element) => element.publicId);
          await this.$services.phonebuyService.createPhoneBuy({
            productName: this.productName,
            productIMEI: this.productIMEI,
            productDateBuy: this.productDateBuy,
            productStatus: this.productStatus,
            productPrice: this.productPrice,
            productGuarran: this.productGuarran,
            paymentMethod: this.productBuyWay,
            customerName: this.productCustomerName,
            customerPhone: this.productCustomerPhone,
            customerIcloud: this.productIcloud,
            customerIcloudPassword: this.productIcloudPassword,
            note: this.productNote,
          });
          this.isLoadingActions = false;
          this.$router.push({ name: "PhoneBuyList" });
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.isLoadingActions = false;
      }
    },
    async onUpdate() {
      this.isLoadingActions = true;
      try {
        const { phonbuyid } = this.$route.params;
        const publicIdList = this.images.map((element) => element.publicId);
        await this.$services.phonebuyService.updatePhoneBuy(phonbuyid, {
          productName: this.productName,
          productIMEI: this.productIMEI,
          productDateBuy: this.productDateBuy,
          productStatus: this.productStatus,
          productGuarran: this.productGuarran,
          productPrice: this.productPrice,
          paymentMethod: this.productBuyWay,
          customerName: this.productCustomerName,
          customerPhone: this.productCustomerPhone,
          customerIcloud: this.productIcloud,
          customerIcloudPassword: this.productIcloudPassword,
          note: this.productNote,
        });
      } catch (err) {
        console.log(err);
      } finally {
        this.isLoadingActions = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.item {
  background-color: #c6c4c1;
  border-radius: 5px;
  .item-count {
    background-color: #474747;
    color: white;
    height: 100%;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
}
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  background: grey;
  opacity: 0.8;
  border: 2px solid transparent;
  border-radius: 5px;
  background-clip: padding-box;
}

::-webkit-scrollbar-track {
  background-color: transparent;
}
</style>
